import { useWindowResize } from 'hooks/useWindowResize';
import { Image, Typography } from 'lib/components';
import React, { useCallback, useState } from 'react';
import Scrollbars from 'react-custom-scrollbars';
import { Job } from 'types';
import classes from './index.module.scss';
import JobRow from './JobRow';
import { HeaderItem, Sort, SortField } from './types';

interface Props {
	jobs: Job[];
	sortField: SortField;
	onSortFieldChange: (sortField: SortField) => void;
}

const HEADER_ITEMS: HeaderItem[] = [
	{ label: 'Status', sort: 'asc', field: 'status' },
	{ label: 'Priority', sort: 'asc', field: 'typeId' },
	{ label: 'Treatment Type', sort: 'asc', field: 'treatmentType' },
	{ label: 'Job ID', sort: 'asc', field: 'jobId' },
	{ label: 'Hospital' },
	{ label: 'Room No.', sort: 'asc', field: 'roomNo' },
	{ label: 'Ordering Physician' },
	{ label: 'Patient Name' },
	{ label: 'Assigned Nurse' },
	{ label: 'Start Time', sort: 'asc', field: 'startTime' },
];

const JobsDataTable: React.FC<Props> = ({ jobs, sortField, onSortFieldChange }: Props) => {
	const [sortFields] = useState(
		HEADER_ITEMS.filter((item) => item.field && item.sort).reduce<Record<string, Sort>>((acc, cur) => {
			if (cur.field && cur.sort) {
				acc[cur.field] = cur!.sort;
			}
			return acc;
		}, {})
	);

	const { isSmallerDevice } = useWindowResize();

	const handleHeaderItemClick = useCallback(
		(headerItem: HeaderItem) => {
			if (headerItem.field && sortFields[headerItem.field]) {
				if (headerItem.field === sortField?.field) {
					onSortFieldChange({
						field: headerItem.field,
						sort: sortField?.sort === 'asc' ? 'desc' : 'asc',
					});
				} else if (sortField?.field !== headerItem.field) {
					onSortFieldChange({ field: headerItem.field, sort: 'desc' });
				}
			}
		},
		[sortField, sortFields, onSortFieldChange]
	);

	const renderHeaderItem = (headerItem: HeaderItem) => {
		if (!headerItem.field || !headerItem.sort) {
			return (
				<div key={Math.random()} className={classes['col']}>
					<Typography weight="light" variant={isSmallerDevice ? 'h5' : 'h6'}>
						{headerItem.label}
					</Typography>
					{/* <Image src={'icTableDown'} /> */}
				</div>
			);
		} else {
			return (
				<div
					onClick={() => handleHeaderItemClick(headerItem)}
					key={Math.random()}
					className={classes['col']}
					style={{
						cursor: 'pointer',
					}}
				>
					<Typography weight="light" variant={isSmallerDevice ? 'h5' : 'h6'}>
						{headerItem.label}
					</Typography>
					<Image
						src={'icTableDown'}
						style={{
							marginLeft: '6px',
							transform:
								sortField?.field === headerItem.field && sortField.sort === 'desc'
									? 'rotate(180deg)'
									: 'initial',
						}}
					/>
				</div>
			);
		}
	};
	return (
		<div className={classes['inventories-datatable']}>
			<div className={classes['table-wrapper']}>
				<div className={classes['table-container']}>
					<div className={classes['toolbar']}>{HEADER_ITEMS.map((item) => renderHeaderItem(item))}</div>
					<div className={classes['container']}>
						<Scrollbars
							style={{
								flex: 1,
							}}
						>
							{jobs?.map((job) => (
								<JobRow key={job.id} job={job} />
							))}
						</Scrollbars>
					</div>
				</div>
			</div>
		</div>
	);
};

export default JobsDataTable;
